import { render, staticRenderFns } from "./customer-list.vue?vue&type=template&id=206b3a8a&scoped=true&"
import script from "./customer-list.vue?vue&type=script&lang=js&"
export * from "./customer-list.vue?vue&type=script&lang=js&"
import style0 from "./customer-list.vue?vue&type=style&index=0&id=206b3a8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206b3a8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('206b3a8a')) {
      api.createRecord('206b3a8a', component.options)
    } else {
      api.reload('206b3a8a', component.options)
    }
    module.hot.accept("./customer-list.vue?vue&type=template&id=206b3a8a&scoped=true&", function () {
      api.rerender('206b3a8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/DaShan_budget_rules/form/customer-list.vue"
export default component.exports